import { render } from "./BoxShadow.vue?vue&type=template&id=251bb6a9&scoped=true&ts=true"
import script from "./BoxShadow.vue?vue&type=script&lang=ts"
export * from "./BoxShadow.vue?vue&type=script&lang=ts"

import "./BoxShadow.vue?vue&type=style&index=0&id=251bb6a9&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251bb6a9"]])

export default __exports__